"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeYesNoLimited = exports.getDietLabel = exports.fullAllergiesSet = exports.dietsWithoutAllergiesSet = exports.dietsWithFullAllergies = exports.fullAllergies = exports.allergies = exports.dietsWithoutAllergies = exports.diets = void 0;
exports.diets = [
    "allergy",
    "dairy-free",
    "gluten-free",
    "vegan",
    "vegetarian",
];
exports.dietsWithoutAllergies = exports.diets.filter((diet) => diet !== "allergy");
exports.allergies = [
    "dairy",
    "eggs",
    "gluten",
    "nuts",
    "shellfish",
    "soba",
];
exports.fullAllergies = exports.allergies.map((allergy) => `allergy@${allergy}`);
exports.dietsWithFullAllergies = [
    ...exports.dietsWithoutAllergies,
    ...exports.fullAllergies,
];
exports.dietsWithoutAllergiesSet = new Set(exports.dietsWithoutAllergies);
exports.fullAllergiesSet = new Set(exports.fullAllergies);
const getDietLabel = (diet) => diet.split("allergy@").slice(-1)[0] ?? diet;
exports.getDietLabel = getDietLabel;
const yesNoLimited = ["no", "limited", "yes"];
const mergeYesNoLimited = (a, b) => yesNoLimited.find((isPossible) => a === isPossible || b === isPossible) ??
    null;
exports.mergeYesNoLimited = mergeYesNoLimited;
//# sourceMappingURL=diets.js.map